/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the Operation interface.
 */
export function instanceOfOperation(value) {
    let isInstance = true;
    return isInstance;
}
export function OperationFromJSON(json) {
    return OperationFromJSONTyped(json, false);
}
export function OperationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'op': !exists(json, 'op') ? undefined : json['op'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'path': !exists(json, 'path') ? undefined : json['path'],
    };
}
export function OperationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'op': value.op,
        'value': value.value,
        'path': value.path,
    };
}
